import React, { Component } from 'react';
import { withTranslation, Translation, } from 'react-i18next';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';

import { Image, View, ActivityIndicator} from "react-native-web";

/*import HeaderPC from '../../header/HeaderPC';
import HeaderMobile from '../../header/HeaderMobile';
import HeaderTablet from '../../header/HeaderTablet';*/

const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

export default function LoadingPage() {




    return (

	         <div>


                  {!isMobileOnly && !isTablet &&
                    <BrowserView>
                    <View style={{width: viewportWidth+'px', height: (viewportHeight-70)+'px', alignItems: 'center', justifyContent: 'center'}}>



                         <Image source={{uri: '/img/storrypage_logo_trans.png'}} style={{width: '400px', height: '94px'}}/>

                         <View style={{height: '40px'}}/>

                         <ActivityIndicator  animating={true} color="#0b49ff" />



                    </View>
                   </BrowserView>
                 }



                 {isMobileOnly &&
           			  <MobileView>
                    <View style={{width:viewportWidth, height: viewportHeight, justifyContent: 'center', alignSelf: 'center'}}>




                      <View><ActivityIndicator  animating={true} color="#0b49ff" /></View>

                        <View><div style={{clear:'both', height: '50px'}}></div></View>

                        <View><div style={{width: '60%', margin: 'auto', textAlign: 'center'}}><img src={'/img/storrypage_logo_trans.png'} style={{width: '100%'}}/></div></View>



                    </View>
           			 </MobileView>
           			}

           			{isTablet &&
           			  <TabletView>
                      <View style={{width:viewportWidth, height: viewportHeight, justifyContent: 'center', alignSelf: 'center'}}>




                        <View><ActivityIndicator  animating={true} color="#0b49ff" /></View>

                          <View><div style={{clear:'both', height: '50px'}}></div></View>

                          <View><div style={{width: '500px', margin: 'auto', textAlign: 'center'}}><img src={'/img/storrypage_logo_trans.png'} style={{width: '500px'}}/></div></View>



                      </View>
           			  </TabletView>
           			}








	        </div>

    )

}
